import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";

export const fetchRoles = async (pageNo: number, dataLength: number, sorting: any, callback: any, errorCallback: any) => {
    axios.get(`${BASEDOMAIN}/role/list?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
};

export const fetchAllRoles = async (callback: any, errorCallback: any) => {
    axios.get(`${BASEDOMAIN}/role/list`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
}

export const saveRole = async (data: any, callback: any, errorCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/role`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
}

export const getRolesListFromAPI = async () => {
    return await axios.get(`${BASEDOMAIN}/role/list`, AuthConfig())
}
export const getRoleById = async (id: string, callback: any, errorCallback: any) => {
    axios.get(`${BASEDOMAIN}/role/${id}`, AuthConfig())
    .then((response) => {
        callback(response);
    })
    .catch((e) => {
        console.log(e);
        errorCallback(e);
    });
}

export const getRoleUsers = async (id: string, dataLength: number, pageNo: number, callback: any, errorCallback: any) => {
    axios.get(`${BASEDOMAIN}/role/${id}/users?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}`, AuthConfig())
    .then((response) => {
        callback(response);
    })
    .catch((e) => {
        console.log(e);
        errorCallback(e);
    });
} 

export const getRoleGroups = async (id: string, callback: any, errorCallback: any) => {
    axios.get(`${BASEDOMAIN}/role/${id}/groups`, AuthConfig())
    .then((response) => {
        callback(response);
    })
    .catch((e) => {
        console.log(e);
        errorCallback(e);
    });
}

export const updateRole = async (id: string, data: any, callback: any, errorCallback: any) => {
    axios.patch(`${BASEDOMAIN}/role/${id}`, data, AuthConfig())
    .then((response) => {
        callback(response);
    })
    .catch((e) => {
        console.log(e);
        errorCallback(e);
    });
}